import {
  IRegularization,
  IRegularizationData,
  IRegularizationTableData,
} from '@/interfaces/regularization.model';
import moment from 'moment';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Modal } from 'reactstrap';
import FormButtons from '../common/Form/FormButtons';
import { useEffect, useState } from 'react';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { callApi, IApiErrorResponse } from '@/api/callApi';
import { IDeleteResponse } from '@/interfaces/common.model';
import { getFilterUrl, showToastNotification } from '@/utility/helper';
import PrimaryInput from '../ui/PrimaryInput';
import FieldLayout from '../Layout/FieldLayout';
import Label from '../ui/Label';
import Button from '../ui/Button';
import { errorTypes } from '@/utility/validation';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { IAttendanceRecord } from '@/interfaces/attendance.model';
interface IAddRegularizationModalProps {
  isOpen: boolean;
  toggle: (type?: string) => void;
  editData?: IRegularizationTableData | null;
  setData: React.Dispatch<React.SetStateAction<IRegularizationData>>;
  getAr: () => void;
}
interface IFile {
  file: null | File;
  imageUrl: null | string;
  deleteUrl: null | string;
  isDelete: boolean;
}
interface IAttendanceDetailResponse {
  status: boolean;
  message: string;
  data: { attendances: IAttendanceRecord[] };
}

const AddRegularizationModal = ({
  editData,
  toggle,
  isOpen,
  setData,
  getAr,
}: IAddRegularizationModalProps) => {
  const {
    register,
    clearErrors,
    reset,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<IRegularization>();
  const userData = useSelector((state: RootState) => state?.user?.user);
  const [attendanceId, setAttendanceId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [isHalfday, setIsHalfday] = useState<boolean>(false);
  const [file, setFile] = useState<IFile>({
    file: null,
    imageUrl: null,
    deleteUrl: null,
    isDelete: false,
  });

  const onSubmit: SubmitHandler<IRegularization> = async (data) => {
    const postData = {
      ...(editData !== null && {
        arRequestId: editData?.Arrequests[0]?.id,
      }),
      ...(attendanceId !== null && {
        attendanceId: attendanceId,
      }),
      attendanceStatus: 'pending',
      workType: data?.wrktyp,
      reason: data?.reason,
      checkInTime: `${data?.checkindate}T${data?.checkintime}`,
      checkOutTime: `${data?.checkoutdate}T${data?.chkout}`,
      document: file?.file,
      ...(file?.isDelete && { deleteDocument: file?.deleteUrl }),
    };
    const formData = new FormData();
    (Object.keys(postData) as Array<keyof typeof postData>).forEach((key) => {
      const value = postData[key];
      if (value !== null && value !== undefined && value !== '') {
        formData.append(key, value as string | Blob);
      }
    });

    setIsLoading(true);

    try {
      const response: IDeleteResponse = await callApi(
        editData
          ? API_URL + API_ENDPOINT.editAr
          : API_URL + API_ENDPOINT.createAr,
        { method: 'POST', data: formData, multipart: true },
      );

      if (response?.status) {
        showToastNotification('success', response?.message);
        getAr();
        setData((prev) => ({ ...prev, EditArData: null }));
        toggle();
        setAttendanceId(null);
        reset();
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteDocument = () => {
    setFile((pre) => ({
      ...pre,
      file: null,
      imageUrl: null,
      isDelete: editData !== null ? !pre.isDelete : pre.isDelete,
    }));
  };
  useEffect(() => {
    if (editData) {
      const startDate = moment(editData?.checkInTime).format('YYYY-MM-DD');
      const endDate = moment(editData?.checkOutTime).format('YYYY-MM-DD');
      const checkInTime = editData?.checkInTime
        ?.split('T')[1]
        .split(':')
        .slice(0, 2)
        .join(':');
      const checkOutTime = editData?.checkOutTime
        ?.split('T')[1]
        .split(':')
        .slice(0, 2)
        .join(':');

      // setValue('attsts', editData?.Arrequests[0]?.attendanceStatus);
      // setValue('wrktyp', editData?.workType);
      setValue('reason', editData?.reasonAr);
      setValue('checkindate', startDate);
      setValue('checkoutdate', endDate);
      setValue('checkintime', checkInTime);
      setValue('chkout', checkOutTime);
      setFile((pre) => ({
        ...pre,
        // imageUrl: editData?.document,
        // deleteUrl: editData?.document,
      }));
    } else {
      reset();
    }
  }, [editData, isOpen]);
  const toggleModal = () => {
    setData((prev) => ({ ...prev, editArData: null }));
    setAttendanceId(null);
    toggle();
  };

  const getAttendanceDetail = async (data: string) => {
    try {
      const filter = {
        userId: userData?.id,
        startDate: data,
        endDate: data,
      };
      const API = `${API_URL}${API_ENDPOINT?.getAttendanceDetail}?${getFilterUrl(filter)}`;
      const response: IAttendanceDetailResponse = await callApi(API, {
        method: 'GET',
      });
      if (response?.status === true) {
        response?.data?.attendances?.map((data) => {
          setAttendanceId(data?.id);
        });
        console.log('AttendanceDetail: ', response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      className="modal-dialog modal-dialog-scrollable modal-dialog-centered"
      isOpen={isOpen}
      toggle={() => {
        toggleModal();
        clearErrors();
        reset();
      }}
    >
      <div className="modal-content">
        <div className="modal-header p-4 border-0">
          <h1
            className="modal-title fs-3 rajdhani-semibold"
            id="attendanceModalLabel"
          >
            {editData !== null ? 'Edit Regularization' : 'Apply Regularization'}
          </h1>
          <Button
            type="button"
            className="btn-close "
            onClick={() => {
              clearErrors();
              reset();
              setData((pre) => ({ ...pre, editData: null }));
              toggle();
            }}
          />
        </div>
        <div className="modal-body p-4">
          <form
            className="row"
            onSubmit={handleSubmit(onSubmit)}
            id="ArRequestForm"
          >
            {/* <div className="col-12">
              <div className="form-group mb-3">
                <label htmlFor="wrktyp" className="form-label">
                  Work Type <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  aria-label="Default select example"
                  id="wrktyp"
                  {...register('wrktyp', {
                    required: 'Work type is required',
                  })}
                />

                {errors.wrktyp && (
                  <div className="text-danger">{errors.wrktyp.message}</div>
                )}
              </div>
            </div> */}
            <FieldLayout>
              <PrimaryInput
                id="chkindate"
                required={true}
                value={watch('checkindate')}
                label="Check In Date"
                type="date"
                errors={errors?.checkindate?.message}
                className="form-control"
                {...register('checkindate', {
                  ...errorTypes.required('Check-in date'),
                  ...errorTypes.checkInDate(watch('checkoutdate')),
                })}
                onChange={(e) => {
                  const val = e.target.value;
                  if (moment(val).day() === 0) {
                    return;
                  }
                  setValue('checkindate', val);
                  setValue('checkoutdate', val);
                  getAttendanceDetail(val);
                }}
                max={moment().format('YYYY-MM-DD')}
                defaultValue={moment().format('YYYY-MM-DD')}
              />
            </FieldLayout>
            <FieldLayout>
              <PrimaryInput
                id="chkintime"
                required={true}
                label="Check In Time"
                type="time"
                errors={errors?.checkintime?.message}
                className="form-control"
                max={moment().format('YYYY-MM-DD')}
                {...register('checkintime', {
                  ...errorTypes.required('Check-in time'),
                  ...errorTypes.checkInTime(watch('chkout')),
                })}
              />
            </FieldLayout>
            <FieldLayout>
              <PrimaryInput
                id="chkoutdate"
                required={true}
                value={watch('checkoutdate')}
                label="Check Out Date"
                type="date"
                errors={errors?.checkoutdate?.message}
                {...register('checkoutdate', {
                  ...errorTypes.required('Check-out date'),
                  ...errorTypes.checkOutDate(watch('checkindate')),
                })}
                max={watch('checkindate')}
                defaultValue={
                  watch('checkindate')
                    ? watch('checkindate')
                    : moment().format('YYYY-MM-DD')
                }
              />
            </FieldLayout>
            <FieldLayout>
              <PrimaryInput
                id="chkout"
                required={true}
                label="Check Out Time"
                type="time"
                errors={errors?.chkout?.message}
                {...register('chkout', {
                  ...errorTypes.required('Check-out time'),
                  ...errorTypes.checkOutTime(watch('checkintime')),
                })}
              />
            </FieldLayout>
            <div className="col-12">
              <div className="form-group mb-3">
                <Label id="desc">Reason</Label>
                <textarea
                  className="form-control"
                  rows={3}
                  id="reason"
                  placeholder="Enter reason here"
                  {...register(
                    'reason',
                    // { required: "Reason is required" }
                  )}
                />
                {errors.reason && (
                  <div className="text-danger">{errors.reason.message}</div>
                )}
              </div>
            </div>
            <div className="col-12">
              <div className="form-group mb-3">
                <label htmlFor="desc" className="form-label">
                  Attachment
                </label>
                {!file?.imageUrl ? (
                  <input
                    type="file"
                    className="form-control"
                    id="desc"
                    placeholder="Choose file"
                    {...register(
                      'url',
                      // { required: 'Attachment is required' }
                    )}
                    onChange={(e) => {
                      if (!e?.target?.files) return;
                      const file = e?.target.files[0];
                      const imageUrl = URL.createObjectURL(file);
                      setFile((pre) => ({
                        ...pre,
                        file: file,
                        imageUrl: imageUrl,
                      }));
                    }}
                  />
                ) : (
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <img
                      loading="lazy"
                      src={file?.imageUrl}
                      alt=""
                      className="w-50"
                    />
                    <div className="">
                      <Button
                        className="btn btn-danger btn-sm"
                        onClick={() => {
                          handleDeleteDocument();
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                )}
                {/* {errors.url && <div className="form-text text-danger">{errors.url.message}</div>} */}
              </div>
            </div>
            <FormButtons isLoading={isLoading} toggleModal={toggleModal}>
              {editData ? 'Update' : 'Apply'}
            </FormButtons>
          </form>
        </div>
      </div>
    </Modal>
  );
};
export default AddRegularizationModal;
